import { render, staticRenderFns } from "./recommend.vue?vue&type=template&id=7ab214ac&scoped=true&"
import script from "./recommend.vue?vue&type=script&lang=js&"
export * from "./recommend.vue?vue&type=script&lang=js&"
import style0 from "./recommend.vue?vue&type=style&index=0&id=7ab214ac&lang=scss&scoped=true&"
import style1 from "./recommend.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab214ac",
  null
  
)

export default component.exports